import React from 'react';
import PropTypes from 'prop-types';
import { ImageIcon, CoinIcon } from '../../../model/icons';

// Карточка шаблона (.sp-task): фото, название, стоимость, чипы подкатегории/цели.
export default function TemplateCard({ template, subcategories, onClick }) {
    const url = template.mediaFile?.mediaFileUrl;
    const subName = subcategories.find(s => s.id === template.subcategoryId)?.name;
    return (
        <div className="sp-task" role="button" tabIndex={0} onClick={onClick} onKeyDown={(e) => { if (e.key === 'Enter') onClick(); }}>
            <div className="sp-tphoto">
                {url ? <img src={url} alt="" /> : <span className="ph"><ImageIcon /></span>}
            </div>
            <div className="sp-tinfo">
                <div className="sp-ttop">
                    <div className="sp-tname">{template.title}</div>
                    <div className="sp-tcost">{template.cost} <CoinIcon /></div>
                </div>
                <div className="sp-tmchips">
                    {template.isChallenge && <span className="sp-tmchip challenge">Челлендж</span>}
                    {subName && <span className="sp-tmchip">{subName}</span>}
                    {template.withTargetUser && <span className="sp-tmchip">С целью</span>}
                </div>
            </div>
        </div>
    );
}

TemplateCard.propTypes = {
    template: PropTypes.object.isRequired,
    subcategories: PropTypes.array.isRequired,
    onClick: PropTypes.func.isRequired
};
